import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

const EnterpriseLogo = (boxProps: BoxProps) => (
  <Box {...boxProps}>
    <svg
      width="100%"
      height="100%"
      display="inline-block"
      viewBox="0 0 32 32"
      fill="currentColor"
      aria-hidden
      focusable={false}
    >
      <g transform="translate(4.8 4.8) scale(0.7)">
        <rect x="8" y="8" width="2" height="4" />
        <rect x="8" y="14" width="2" height="4" />
        <rect x="14" y="8" width="2" height="4" />
        <rect x="14" y="14" width="2" height="4" />
        <rect x="8" y="20" width="2" height="4" />
        <rect x="14" y="20" width="2" height="4" />
        <path d="M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z" />
      </g>
    </svg>
  </Box>
);

export default EnterpriseLogo;
